import PropTypes from 'prop-types';
import SearchFilterUtil from 'lib/SearchFilterUtil';
import { PRICE_OPTIONS_MIN, PRICE_OPTIONS_MAX } from 'constants/filterOptions';
import { validatePrice } from 'lib/Validations';
import RangeAutocomplete from 'components/FilterFields/RangeAutocomplete';
import RentalPriceFilter from 'components/FilterFields/RentalPriceFilter';

function PriceFilter(props) {
    const validateInput = (input) => {
        return validatePrice(SearchFilterUtil.getNumericValue(SearchFilterUtil.expandAndFormatPrice(input)));
    };
    
    return props.hasRentalFrequencyTabs
        ? (
            <RentalPriceFilter
                subLabel={props.subLabel}
                outlined={!props.isDropdown}
                isDropdown={props.isDropdown}
            />
        )
        : (
            <RangeAutocomplete
                comparableType={props.comparableType}
                attrName={props.attrName}
                label={props.label}
                subLabel={props.subLabel}
                minOptions={PRICE_OPTIONS_MIN}
                maxOptions={PRICE_OPTIONS_MAX}
                formatter={SearchFilterUtil.expandAndFormatPrice}
                validateInput={validateInput}
                isDropdown={props.isDropdown}
                valueFormatter={SearchFilterUtil.formatPriceRangeDisplay}
                dropdownDisplayFormatter={SearchFilterUtil.getDisplayPriceValue}
                maxInputLength={14}
                showValueAsTooltip
            />
        );
}

PriceFilter.propTypes = {
    comparableType: PropTypes.string.isRequired,
    attrName: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    subLabel: PropTypes.string,
    isDropdown: PropTypes.bool,
    hasRentalFrequencyTabs: PropTypes.bool,
};

export default PriceFilter;
